<template>
	<n-config-provider :theme="darkTheme"
		:theme-overrides="theme">
		<n-message-provider>
			<n-scrollbar style="max-height: 100vh">
				<div id="app-style">
					<nav class="nav">
						<div class="container">
							<router-link to="/"
								class="nav-brand">
								<div class="nav-brand-title">
									<div class="nav-brand-title-first">WIKI</div>
									<div class="nav-brand-title-second">
										<span>BLACK</span>
										RUSSIA
									</div>
								</div>
							</router-link>
							<router-link v-if="store.state.admin.token !== null"
								to="/admin">
								<n-button strong
									secondary>
									Панель администратора</n-button>
							</router-link>
							<router-link v-else
								to="/login">
								<n-button size="small">
									Войти
								</n-button>
							</router-link>

						</div>
					</nav>
					<main>
						<router-view />
					</main>
					<footer class="footer">
						<div class="container">
							<div class="footer-cred">
								© ВСЕ ПРАВА ЗАЩИЩЕНЫ ООО "БЛЕКХАБ ГЕЙМС"
							</div>
						</div>
					</footer>
				</div>
			</n-scrollbar>
		</n-message-provider>
	</n-config-provider>


</template>

<script setup>

import { darkTheme } from "naive-ui"
import { onMounted } from "vue"
import { checkToken } from "@/extensions/funcs"
import { useStore } from "vuex"
const store = useStore()

const theme = {
	"Menu": {
		"itemTextColorActive": "#FFFFFFFF",
		"itemTextColorActiveHover": "#5587FCFF",
		"itemTextColorChildActive": "#63e2b7",
		"itemIconColorActive": "#5587FCFF",
		"itemIconColorActiveHover": "#5587FCFF",
		"itemColorActiveInverted": "rgb(42, 148, 125)",
		"itemColorActiveCollapsedInverted": "rgb(42, 148, 125)",
		"itemTextColorHorizontalInverted": "#BBB",
		"itemColorActiveHoverInverted": "rgb(42, 148, 125)",
		"arrowColorChildActiveHover": "#63e2b7",
		"arrowColorChildActive": "#63e2b7",
		"arrowColorActiveHover": "#63e2b7",
		"arrowColorActive": "#63e2b7",
		"itemIconColorChildActiveHorizontal": "#63e2b7",
		"itemIconColorActiveHorizontal": "#63e2b7",
		"itemIconColorHoverHorizontal": "#7fe7c4",
		"itemIconColorChildActiveHover": "#63e2b7",
		"itemIconColorChildActive": "#63e2b7",
		"itemTextColorChildActiveHoverHorizontal": "#63e2b7",
		"itemColorActive": "rgba(40, 63, 116, 0.29)",
		"itemColorActiveHover": "rgba(23, 30, 61, 0.15)",
		"itemColorHover": "rgba(0, 2, 57, 0.09)"
	},
	"Input": {
		"boxShadowFocus": "0 0 0 1px rgba(112,192,232,0.3)",
		"borderFocus": "1px solid #70c0e8",
		"borderHover": "1px solid #70c0e8",
		"caretColor": "#70c0e8"
	},
}

onMounted(() => {
	checkToken()
	setInterval(() => {
		checkToken()
	}, 2000)
})
</script>

<style lang="scss">
  @import "style.scss";
</style>